export class CCAvenueDataFormat
{
    amount : number;
    orderId : string;
    merchantId : string;
    source : string;
    validTill : string;
}